export default function timestampToDate(timestamp: number | undefined) {
  // if (!timestamp) {
  //   const dateObj = new Date();
  //   const dateString = dateObj.toLocaleDateString();
  //   return formatDate(timestamp);
  // }
  // const dateObj = new Date(timestamp);
  // const dateString = dateObj.toLocaleDateString();
  return formatDate(timestamp);
}

// function formatDate(time: any): string {
//   const date = new Date(time);
//   const YY = date.getFullYear();
//   const MM =
//     date.getMonth() + 1 < 10
//       ? '0' + (date.getMonth() + 1)
//       : date.getMonth() + 1;
//   const DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
//   const hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
//   const mm =
//     date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
//   const ss =
//     date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

//   return YY + '-' + MM + '-' + DD + ' ' + hh + ':' + mm; //+ ":" + ss;
// }

function formatDate(time: any): string {
  const date = new Date(time);
  // Helper function to pad single digits with a leading zero
  const pad = (num: number) => num.toString().padStart(2, '0');
  const YY = date.getFullYear();
  const MM = pad(date.getMonth() + 1);
  const DD = pad(date.getDate());
  const hh = pad(date.getHours());
  const mm = pad(date.getMinutes());
  // If seconds are needed in the future, just uncomment the following line
  // const ss = pad(date.getSeconds());
  return `${YY}-${MM}-${DD} ${hh}:${mm}`;
}
